import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalLink, DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { blueCheck } from "../../common/icons";

function AiInfoBox() {
    const { translateString } = useTranslation();

    const bullets = [
        translateString("aiBulletEuropeanProvider"),
        translateString("aiBulletNoTraining"),
        translateString("aiBulletNotStored"),
        translateString("aiBulletCanBeDisabled"),
        translateString("aiBulletVerifyOutputs"),
    ];

    return (
        <DotLegalPaper fullHeight>
            <Box sx={{ marginRight: 6, marginLeft: 6, marginTop: 2 }}>
                <DotLegalHeader headerStyle="medium">
                    <Box sx={{ textTransform: "uppercase" }}> {translateString("dotLegalAi")}</Box>
                </DotLegalHeader>

                <Box sx={{ marginTop: 1, display: "flex", flexDirection: "column" }}>
                    {bullets.map((bullet) => (
                        <Box key={bullet} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                            <Box sx={{ width: 14, flexShrink: 0 }}>{blueCheck}</Box>
                            <DotLegalHeader marginBottom={1} headerStyle="small" fontWeight={400}>
                                {bullet}
                            </DotLegalHeader>
                        </Box>
                    ))}
                </Box>

                <DotLegalHeader headerStyle="small" fontWeight={400} marginTop={2}>
                    {translateString("readFullAiTerms")}{" "}
                    <DotLegalLink linkColor="primary" to="https://www.dotlegal.com/en/ai-terms" bold underline openExternalLinkInSameTab={false}>
                        {translateString("here")}
                    </DotLegalLink>
                    .
                </DotLegalHeader>
            </Box>
        </DotLegalPaper>
    );
}

export default AiInfoBox;
